import { gql } from '@apollo/client';


export const GET_VEHICLE_INCIDENT_SPECIFIC = gql`
  query GET_VEHICLE_INCIDENT_SPECIFIC($vehicleIncidentSpecificId: ID!, $originatorId: ID!){
    getVehicleIncidentSpecific(vehicleIncidentSpecificId: $vehicleIncidentSpecificId, originatorId: $originatorId) {
      id
      uuid
      incident {
        id
      }
      abandoned
      impounded
      evidenceStatus
      recoveredValue
      dateStolen
      dateRecovered
      operator {
        id
        personalAttribute {
          id
          firstName
          lastName
        }
      }
      position
      reasonSeized {
        id
        name
      }
      suspectDriven
      wrecker {
        id
        name
      }
      towingDestination {
        id
        name
      }
      usedInCrime
      vehicle {
        id
        uuid
        description
        owner {
          id
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        plateType {
          id
          name
        }
        value
        vehicleColor {
          id
          name
        }
        vehicleMake {
          id
          nhtsaId
          name
        }
        vehicleModel {
          id
          nhtsaId
          name
        }
        vehiclePlate {
          id
          name
        }
        vehicleState {
          id
          name
        }
        vehicleVin {
          id
          name
        }
        year
        validVehicleAlerts {
          alertType {
            id
            name
            alertLevel
            oriId
            position
          }
          expireAt
          id
          notes
          officerId
          vehicle {
            id
          }
        }
      }
      vehicleOfInterest
      vehicleRole {
        id
        name
      }
    }
  }
`;


